import { Employer } from "./employer";
import { Order } from "./orders/shared";
import { Package } from "./package";
import { Partner } from "./partner";
import { Education } from "./education";

export enum orderType {
  online="online", invite="invite",
}

export const ownerShipType = {
  0: "Corporation",
  1: "Join Venture",
  2: "Limited Liability Corporation",
  3: "Limited Liability Partnership",
  4: "Non-Profit",
  5: "Other",
  6: "Partnership",
  7: "Sole Proprietor"
}

export const natureOfBusinesses = {
  0: "Agriculture",
  1: "Business Services",
  2: "Education 12+",
  3: "Education K-12",
  4: "Engineering",
  5: "Finance & Banking",
  6: "Government",
  7: "Healthcare",
  8: "Infrastructure/Construction",
  9: "Insurance",
  10: "Legal",
  11: "Leisure & Hospitality",
  12: "Logistics/Transportation",
  13: "Manufacturing",
  14: "Media",
  15: "Mining",
  16: "Multi-Family Housing",
  17: "Non-Profit",
  18: "Petrochemical",
  19: "Pharmaceutical",
  20: "Public Administration",
  21: "Real Estate",
  22: "Restaurants",
  23: "Retail/E-Commerce",
  24: "Staffing",
  25: "Technology & Communication",
  26: "Utilities",
  27: "Other"
}

export const permissiblePurposes = {
  0: "Pre/Post Employment",
  1: "Volunteer",
  2: "Contractor"
}

export const levelOfEducation = {
  0: "High School",
  1: "College",
  2: "G.E.D.",
  3: "Certificate",
  4: "Vocational School",
  5: "Trade School",
  6: "Technical School"
}

export class Signup {
    firstName: string;
    lastName: string;
    middleName: string;
    companyName:string;
    phoneNumber:string;
    email: string;
    password:string;
    legalCompanyName:string;
    billToAddress:string;
    billToCity:string;
    billToState:string;
    billToZip:string;
    isResidentalAddress:boolean = null;
    ownershiptype:typeof ownerShipType;
    stateofincorporation?:string;
    taxid_ein?:string;
    doyousharespace:boolean = null;
    agreement:boolean;
    packageID:string;
    ordertype:orderType;
    candidatefirstname:string;
    candidatelastname:string;
    candidatemiddlename: string;
    candidateemail:string;
    candidateemailconfirm:string;
    ccfirstname:string;
    cclastname:string;
    ccnumber: string;
    ccmonth: string;
    ccyear: string;
    ccaccountid: string;
    ccprofileid: string;
    ccsecuritycode:string;
    mobilephonenumber:string;
    credentialed:boolean=null;
    order?:Order;
    ID?:number;
    skipSignUp: boolean;
    package?:Package;
    firsttimelogin: boolean;
    ccauthagreement?: string;
    clientagreementsignature?: string;
    clientagreementpermissiblepurpose?: string;
    clientnatureofbusiness?: string;
    othernatureofbusiness?: string;
    firsttimecredential: boolean;
    freeBackground?: boolean;
    freeBackgroundToken?: string;
    HasOutstandingBalance: boolean;
    ContactID: string;
    partner: Partner = new Partner();
    numberOfEmployees: string;
    partnerTierID: string;
    packageGuids: string[] = [];
    campaignToken?:string;
    generateTestToken: boolean;
    testToken: string;
    clientID: number;
    cczip: string;
    ccstate: string;
    ccaddress: string;
    cccity: string;
    cccountry: string;
    ccregion: string;
    ccpostal: string;
    hasCompletedPayment: boolean = false;
    PSAN: string;
}
